import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Avatar, Button, Col, Typography } from "antd";
import { useEffect, useState } from "react";

import { useRecipes, useTableRecipes } from "../hooks";
import Table from "../../../shared/components/ui/Table";
import {
  recipesService,
  recipesCategoriesService,
} from "../../../shared/services";
import { DataRecipe } from "../../../redux/@types";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { PATH_S3_BUCKET } from "../../../shared/utils/constants";

const { Title } = Typography;

export const TableRecipes = () => {
  const { changeRecipeForUpdate, showDeleteConfirm } = useTableRecipes();
  const { setTableProps } = useRecipes();
  const [categories, setCategories] = useState<any[]>([]);

  useEffect(() => {
    recipesCategoriesService
      .find({ query: { $sort: { name: 1 }, $limit: 100 } })
      .then((res) => setCategories(res.data))
      .catch(() => setCategories([]));
  }, []);

  const getCategoryName = (id: number) => {
    const cat = categories.find((c: any) => c.id === id);
    return cat ? cat.name : "-";
  };

  const columns: TableColumns<DataRecipe> = [
    {
      title: "Imagen",
      width: 7,
      dataIndex: "path_cover",
      key: "path_cover",
      render: (_, item) => (
        <Col
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-evenly",
            flexDirection: "row",
          }}
        >
          <Avatar size={64} src={`${PATH_S3_BUCKET}/${item.path_cover}`} />
        </Col>
      ),
    },
    {
      title: "Nombre",
      width: 10,
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Categoría",
      width: 10,
      dataIndex: "category_id",
      key: "category_id",
      render: (_, item) => getCategoryName(item.category_id),
    },
    {
      title: "Calificación",
      width: 6,
      dataIndex: "rating_score",
      key: "rating_score",
    },
    {
      title: "Estado",
      width: 6,
      dataIndex: "status",
      key: "status",
      render: (_, item) => (item.status === "active" ? "Activo" : "Inactivo"),
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 6,
      render: (_, item) => (
        <Col
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-evenly",
            flexDirection: "row",
          }}
        >
          <Button
            type="primary"
            shape="circle"
            onClick={() => changeRecipeForUpdate(item)}
            icon={<EditOutlined />}
            size="large"
          />
          <Button
            type="primary"
            danger
            onClick={() => showDeleteConfirm(item.id, `${item.name}`)}
            shape="circle"
            icon={<DeleteOutlined />}
            size="large"
          />
        </Col>
      ),
    },
  ];

  return (
    <Table<DataRecipe>
      columns={columns}
      fetchQueryProps={{
        $sort: { id: -1 },
      }}
      service={recipesService}
      onLoad={setTableProps}
    />
  );
};
